<template>
  <!-- 底部区域 -->
    <footer class="bg-blue-900 text-white pt-16 pb-8">
      <div class="container mx-auto px-6">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <div class="flex items-center mb-6">
             <img
                src="../assets/headerlog.png"
                alt="Logo"
                class="h-10 mr-2"
              />
              <span class="font-bold text-xl">创达芯仪</span>
            </div>
            
            <div class="flex space-x-4">
            
              <a
                href="#"
                class="text-blue-300 hover:text-white transition-colors duration-300 cursor-pointer"
              >
                <i class="fab fa-weibo text-xl"></i>
              </a>
              <a
                href="#"
                class="text-blue-300 hover:text-white transition-colors duration-300 cursor-pointer"
              >
                <i class="fab fa-linkedin-in text-xl"></i>
              </a>
              <a
                href="#"
                class="text-blue-300 hover:text-white transition-colors duration-300 cursor-pointer"
              >
                <i class="fab fa-twitter text-xl"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h3 class="text-lg font-bold mb-6">产品服务</h3>
            <ul class="space-y-3">
              <li>

              <router-link :to="{ name: 'ProductPage',  query: { id: 1} }"  class="text-blue-200 hover:text-white transition-colors duration-300 cursor-pointer" >AI智慧驱鸟系统</router-link>               
              </li>
              <li>
                 <router-link  :to="{  name: 'ProductPage',  query: { id: 2} }" class="text-blue-200 hover:text-white transition-colors duration-300 cursor-pointer" >城市积水智能监测预警系统</router-link>
              
              </li>
              <li>
               <router-link  :to="{   name: 'ProductPage',   query: { id: 3}  }" class="text-blue-200 hover:text-white transition-colors duration-300 cursor-pointer" >行业AI边缘网关</router-link>
            
              </li>
              <li>
                 <router-link   :to="{   name: 'ProductPage',   query: { id: 4}   }"  class="text-blue-200 hover:text-white transition-colors duration-300 cursor-pointer" >软硬件定制服务</router-link>       
              </li>
              
            </ul>
          </div>
          <div>
            <h3 class="text-lg font-bold mb-6">联系信息</h3>
            <ul class="space-y-3">
              <li class="flex items-start">
                <!-- <i class="fas fa-map-marker-alt mt-1 mr-3 text-blue-400"></i> -->
                <span class="text-blue-200"
                  >成都市高新区观东三街158号6栋23层2306号</span>
            
                <li class="flex items-start">
                <span class="text-blue-200">联系电话: 18583997111,13980710733</span>
              </li>
               <li class="flex items-start">
                <span class="text-blue-200">联系邮箱: Liuj@cnwz-ai.com</span>
              </li>
            
              <li class="flex items-start">
                <!-- <i class="fas fa-clock mt-1 mr-3 text-blue-400"></i> -->
                <span class="text-blue-200">周一至周五: 9:00 - 18:00</span>
              </li>
             
            </ul>
          </div>

          <div>
            <h3 class="text-lg font-bold mb-6">公众号</h3>
            <ul class="space-y-3">

             <!-- <li class="flex items-start">
              <img src="../assets/careus.png" alt="关注我们" style="width: 6rem;"> -->
             <!-- </li> -->
             <li class="flex items-start">
              <img src="../assets/gongzhonghao.jpg" alt="关注我们" style="width: 6rem;">
             </li>
             </ul>
             <br>
             <!-- <h3 class="text-lg font-bold mb-6">公众号</h3> -->
          </div>
          <div>
            
            <ul class="space-y-3">
            
             </ul>
          </div>
        </div>
        <div
          class="pt-8 border-t border-blue-800 text-center text-blue-300 text-sm"
        >
          <p>© 2025 四川创达芯仪科技有限公司. 保留所有权利.</p>
        </div>
      </div>
    </footer>
</template>

<script>
export default {
  name: 'FooterComponent'
}
</script>
